import {Component} from "@angular/core";

@Component({
    selector: "fui-section",
    styleUrls: ["./section.component.scss"],
    templateUrl: "./section.component.html",
    standalone: false
})
export class FUISectionComponent {
}
